import { observable } from 'mobx';
import { deserialize } from 'serializr';
import { Blueprint } from '@vromo/models';

export function EMPTY_BLUEPRINT(): Blueprint {
    return observable(
        deserialize(Blueprint, {
            name: '',
            template: {
                name: '{{name}}',
                tasks: []
            }
        })
    );
}
